module.exports = __webpack_public_path__ + "media/עוגיות.14278468.mp3";